<template>
  <div class="about-page">
    <!-- SEO Meta Tags -->
    <meta name="description" content="Modern Kurs hakkında detaylı bilgi. Misyonumuz, vizyonumuz ve eğitim teknolojilerindeki yenilikçi yaklaşımımız hakkında bilgi edinin." />
    <meta name="keywords" content="Modern Kurs hakkında, eğitim teknolojileri, misyon, vizyon, eğitim yönetimi" />
    <meta name="author" content="Modern Kurs" />
    <meta property="og:title" content="Hakkımızda - Modern Kurs" />
    <meta property="og:description" content="Modern Kurs hakkında detaylı bilgi. Misyonumuz, vizyonumuz ve eğitim teknolojilerindeki yenilikçi yaklaşımımız." />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://modernkurs.com/about" />
    
    <!-- Navigation Bar -->
    <CorporateNavbar />
    
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="container">
        <div class="hero-content">
          <h1 class="hero-title">Hakkımızda</h1>
          <p class="hero-subtitle">Eğitimde Modern Olmak Zamanı</p>
        </div>
      </div>
    </section>

    <!-- Main Content -->
    <main class="main-content">
      <div class="container">
        <!-- Company Story -->
        <section class="company-story" v-if="aboutData">
          <div class="story-content">
            <div class="story-text">
              <h2>{{ aboutData.title || '🏢 Şirket Hikayemiz' }}</h2>
              <p>
                {{ aboutData.content || 'Modern Kurs, 2025 yılında eğitim teknolojilerinde yenilikçi çözümler sunmak amacıyla kuruldu. Eğitim kurumlarının dijital dönüşümüne öncülük eden platformumuz, öğrenci ve eğitmenlerin verimliliğini artırmayı hedefliyor.' }}
              </p>
              <p>
                Gelişmiş randevu sistemi, öğrenci takibi ve detaylı raporlama özelliklerimiz ile 
                eğitim yönetimi artık çok daha kolay ve etkili.
              </p>
            </div>
            <div class="story-image">
              <div class="image-placeholder">
                <img src="@/assets/images/about.webp" alt="Modern Kurs Merkez" class="about-image">
              </div>
            </div>
          </div>
        </section>

        <!-- Mission & Vision -->
        <section class="mission-vision-section">
          <div class="mission-vision-grid">
            <div class="mission-card">
              <div class="card-icon">🎯</div>
              <h3>Misyonumuz</h3>
              <ul class="mission-list">
                <li>Öğrencilerimize akademik başarı kazandırmanın yanı sıra özgüven, sorumluluk ve disiplin bilinci aşılamak.</li>
                <li>Bireysel öğrenme farklılıklarını dikkate alarak, her öğrenciye özel rehberlik ve koçluk desteği sağlamak.</li>
                <li>Alanında uzman öğretmen kadrosuyla kaliteli eğitim sunmak.</li>
                <li>Öğrencilerimizi sadece sınavlara değil, hayata da hazırlamak.</li>
                <li>Velilerle sürekli iletişim halinde olarak, eğitim sürecinde güçlü bir iş birliği kurmak.</li>
              </ul>
            </div>
            <div class="vision-card">
              <div class="card-icon">🗝️</div>
              <h3>Vizyonumuz</h3>
              <ul class="mission-list">
                <li>Eğitimde kaliteyi ve başarıyı en üst düzeye çıkararak, öğrencilerimizin hayallerine ulaşmalarını sağlamak.</li>
                <li>Modern eğitim anlayışıyla, bireysel farklılıkları gözeten, yenilikçi ve çağdaş yöntemlerle öğrencilerimizi geleceğe hazırlamak.</li>
                <li>Hedefimiz; ülkemizin en güvenilir ve en başarılı eğitim kurumlarından biri olmak.</li>
              </ul>
            </div>
          </div>
        </section>

        <!-- Values -->
        <section class="values-section">
          <h2>💎 Değerlerimiz</h2>
          <div class="values-grid">
            <div class="value-card">
              <div class="value-icon">🚀</div>
              <h4>Yenilikçilik</h4>
              <p>Kozan'da Modern Kurs olarak eğitimde sürekli gelişimi benimsiyor, teknolojik yenilikleri derslerimize entegre ederek öğrencilerimize en güncel ve etkili öğrenme ortamını sunuyoruz.</p>
            </div>
            <div class="value-card">
              <div class="value-icon">🤝</div>
              <h4>Güvenilirlik</h4>
              <p>Öğrencilerimizin ve velilerimizin güvenini kazanmak ve korumak en büyük önceliğimizdir. Modern Kurs, söz verdiği eğitim anlayışını eksiksiz yerine getirir.</p>
            </div>
            <div class="value-card">
              <div class="value-icon">📈</div>
              <h4>Kalite</h4>
              <p>Alanında uzman öğretmen kadromuzla, öğrencilerimize en yüksek kalitede eğitim hizmeti sunuyor; başarıya giden yolda güçlü bir rehberlik sağlıyoruz.</p>
            </div>
            <div class="value-card">
              <div class="value-icon">🌍</div>
              <h4>Geleceğe Yatırım</h4>
              <p>Modern Kurs olarak bizler, öğrencilerimizi yalnızca bugünkü sınavlara değil, gelecekteki hayatlarına da hazırlıyoruz. Eğitim anlayışımızda bilgi, disiplin ve özgüveni bir araya getirerek gençlerimize kalıcı bir yol haritası sunuyoruz.</p>
            </div>
          </div>
        </section>



        <!-- Stats -->
        <section class="stats-section">
          <div class="stats-grid">
            <div class="stat-item">
              <div class="stat-number">2000+</div>
              <div class="stat-label">Eğitim Almış Öğrenci</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">500+</div>
              <div class="stat-label">Tamamlanan Deneme Sınavı</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">10K+</div>
              <div class="stat-label">Tamamlanan Randevu</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">99.9%</div>
              <div class="stat-label">Öğrenci Memnuniyeti</div>
            </div>
          </div>
        </section>

        <!-- CTA -->
        <section class="cta-section">
          <div class="cta-content">
            <h2>🚀 Hemen Başlayın</h2>
            <p>Modern Kurs ile eğitim yönetiminizi dijitalleştirin</p>
            <div class="cta-buttons">

              <router-link to="/contact" class="btn btn-outline">
                İletişime Geçin
              </router-link>
            </div>
          </div>
        </section>
      </div>
    </main>
    
    <!-- WhatsApp Floating Button -->
    <WhatsAppButton />

    <!-- Footer -->
    <CorporateFooter />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import CorporateNavbar from '@/components/CorporateNavbar.vue'
import CorporateFooter from '@/components/CorporateFooter.vue'
import WhatsAppButton from '@/components/WhatsAppButton.vue'

export default {
  name: 'About',
  components: {
    CorporateNavbar,
    CorporateFooter,
    WhatsAppButton
  },
  setup() {
    // About sayfası statik verileri
    const aboutData = ref({
      title: 'Modern Kurs Hakkında',
      content: 'Modern Kurs, eğitimde kaliteyi ve yeniliği bir araya getiren, öğrencilerin potansiyellerini en üst düzeye çıkarmalarına yardımcı olan bir eğitim kurumudur.',
      mission: 'Öğrencilerimize akademik başarı kazandırmanın yanı sıra özgüven, sorumluluk ve disiplin bilinci aşılamak.\n Bireysel öğrenme farklılıklarını dikkate alarak, her öğrenciye özel rehberlik ve koçluk desteği sağlamak.\n Alanında uzman öğretmen kadrosuyla kaliteli eğitim sunmak.\n Öğrencilerimizi sadece sınavlara değil, hayata da hazırlamak.\n Velilerle sürekli iletişim halinde olarak, eğitim sürecinde güçlü bir iş birliği kurmak.',
      vision: 'Eğitimde mükemmelliği hedefleyen, yenilikçi ve güvenilir bir eğitim kurumu olmak.'
    })
    
    return {
      aboutData
    }
  }
}
</script>

<style scoped>
.about-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  margin-top: 80px; /* Navbar yüksekliği kadar margin */
  overflow-x: hidden;
  width: 100%;
}



/* Hero Section */
.hero-section {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  color: white;
  padding: 3rem 0;
  text-align: center;
  margin-top: 55px;
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
  opacity: 0.3;
}

.hero-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  position: relative;
  z-index: 1;
}

.hero-subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
  position: relative;
  z-index: 1;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Main Content */
.main-content {
  padding: 4rem 0;
  flex: 1;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  overflow-x: hidden;
  width: 100%;
}

/* Company Story */
.company-story {
  margin-bottom: 5rem;
}

.story-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.story-text h2 {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 2rem;
}

.story-text p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  margin-bottom: 1.5rem;
}

.story-image {
  text-align: center;
}

.image-placeholder {
  background: transparent;
  border-radius: 0;
  padding: 0;
  border: none;
}

.about-image {
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 0;
  margin: 0;
  box-shadow: none;
}



/* Mission & Vision */
.mission-vision-section {
  margin-bottom: 5rem;
}

.mission-vision-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
}

.mission-card, .vision-card {
  background: white;
  padding: 3rem;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s ease;
}

.mission-card:hover, .vision-card:hover {
  transform: translateY(-5px);
}

.card-icon {
  font-size: 4rem;
  margin-bottom: 1.5rem;
}

.mission-card h3, .vision-card h3 {
  font-size: 1.8rem;
  color: #2c3e50;
  margin-bottom: 1.5rem;
}

.mission-card p, .vision-card p {
  font-size: 1.1rem;
  line-height: 1.7;
  color: #555;
}

.mission-list {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.mission-list li {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #555;
  margin-bottom: 1rem;
  padding-left: 1.5rem;
  position: relative;
}

.mission-list li:before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #667eea;
  font-weight: bold;
  font-size: 1.2rem;
}

.mission-list li:last-child {
  margin-bottom: 0;
}

/* Values */
.values-section {
  margin-bottom: 5rem;
  text-align: center;
}

.values-section h2 {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 3rem;
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.value-card {
  background: white;
  padding: 2.5rem 2rem;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.value-card:hover {
  transform: translateY(-5px);
}

.value-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.value-card h4 {
  font-size: 1.3rem;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.value-card p {
  color: #555;
  line-height: 1.6;
  text-align: left;
}



/* Stats */
.stats-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 4rem 0;
  margin-bottom: 5rem;
  border-radius: 20px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 3rem;
  text-align: center;
}

.stat-number {
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 1rem;
  color: #ffd700;
}

.stat-label {
  font-size: 1.1rem;
  opacity: 0.9;
}

/* CTA */
.cta-section {
  text-align: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 4rem 2rem;
  border-radius: 20px;
}

.cta-content h2 {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.cta-content p {
  font-size: 1.2rem;
  color: #555;
  margin-bottom: 2rem;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

/* Buttons */
.btn-outline {
  display: inline-block;
  padding: 15px 30px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  border: 2px solid #667eea;
  cursor: pointer;
  background: transparent;
  color: #667eea;
}

.btn-outline:hover {
  background: #667eea;
  color: white;
  transform: translateY(-3px);
}

/* Responsive */
@media (max-width: 1200px) {
  .container {
    max-width: 1000px;
    padding: 0 2rem;
  }
  
  .values-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
  }
  
  .stats-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .container {
    max-width: 100%;
    padding: 0 1.5rem;
  }
  
  .hero-title {
    font-size: 2.5rem;
  }
  
  .story-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .mission-vision-grid {
    grid-template-columns: 1fr;
  }
  
  .mission-list {
    text-align: center;
  }
  
  .mission-list li {
    padding-left: 0;
    padding-top: 0.5rem;
  }
  
  .mission-list li:before {
    position: static;
    margin-right: 0.5rem;
  }
  
  .values-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
  
  .team-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
  
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .value-card {
    padding: 2rem 1.5rem;
  }
  
  .value-icon {
    font-size: 2.5rem;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 2rem;
  }
  
  .container {
    padding: 0 1rem;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
}
</style>
